import { registerIngenicoPlugin } from "./utils/registerIngenicoPlugin"
import { App as CapacitorApp } from "@capacitor/app"

type IActionsPlugin = {
  exitApp: () => Promise<void>
}

const { platform } = useDevice()

export const IActions: IActionsPlugin =
  platform === "ingenicoNerpay"
    ? registerIngenicoPlugin<IActionsPlugin>(
        "IActionsPlugin"
      )
    : {
        exitApp: CapacitorApp.exitApp,
      }
